export const englishCrmMessages = {
  resources: {
    subscribers: {
      name: "Mail List |||| Mail List",
    },
    feature_cohorts: {
      name: "Feature Cohorts |||| Feature Cohorts",
    },
    feature_cohort_members: {
      name: "Cohort Member |||| Cohort Members",
    },
    agencies: {
      name: "Agency |||| Agencies",
    },
    agency_members: {
      name: "Agency Member |||| Agency Members",
    },
    agency_portal_users: {
      name: "Portal User |||| Portal Users",
    },
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
      filters: {
        only_mine: "Only companies I manage",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        last_echo_at: "Last echo started",
        average_rating: "Average stars",
        use_count: "Uses",
        completed_echo_count: "Completed echoes",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        phone_country_iso2: "Country",
        phone_country_name: "Country",
        phone_continent_code: "Continent",
        phone_continent_name: "Continent",
        phone_geo_status: "Phone geography",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      broadcast: {
        action: "Broadcast",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
        button: "Import CSV",
        complete:
          "Contacts import complete. Imported %{importCount} contacts, with %{errorCount} errors",
        progress:
          "Imported %{importCount} / %{rowCount} contacts, with %{errorCount} errors.",
        error:
          "Failed to import this file, please make sure your provided a valid CSV file.",
        imported: "Imported",
        remaining_time: "Estimated remaining time:",
        running: "The import is running, please do not close this tab.",
        sample_download: "Download CSV sample",
        sample_hint: "Here is a sample CSV file you can use as a template",
        stop: "Stop import",
        csv_file: "CSV File",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      metrics: {
        uses: "%{smart_count} use |||| %{smart_count} uses",
        completed:
          "%{smart_count} completed echo |||| %{smart_count} completed echoes",
        average_rating: "%{rating} stars",
        unrated: "Unrated",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        noop: "Selected contacts already have this tag",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        geography: "Geography",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    whatsapp_templates: {
      name: "WhatsApp Template |||| WhatsApp Templates",
      forcedCaseName: "WhatsApp Template",
    },
    whatsapp_broadcasts: {
      name: "WhatsApp Broadcast |||| WhatsApp Broadcasts",
      forcedCaseName: "WhatsApp Broadcast",
    },
    tepone_codes: {
      name: "Te Pone |||| Te Pone",
      forcedCaseName: "Te Pone",
    },
    echoflicks_video_sessions: {
      name: "Video Session |||| Video Sessions",
      forcedCaseName: "Video Session",
      fields: {
        movie_title: "Movie title",
        script_title: "Script title",
        contact_name: "Contact",
        whatsapp_user_id: "WhatsApp ID",
        session_id: "Session ID",
        workload_id: "Workload ID",
        status: "Status",
        source_confidence: "Confidence",
        media_count: "Media count",
        uploaded_media_count: "Uploaded media",
        rating: "Rating",
        display_date: "Date",
      },
      empty:
        "No video sessions found. Run the local Echoflicks importer to load the legacy media export.",
    },
    echoflicks_echoes: {
      name: "Echo |||| Echoes",
      forcedCaseName: "Echo",
      fields: {
        movie_title: "Echo title",
        script_title: "Script title",
        contact_name: "Contact",
        whatsapp_user_id: "WhatsApp ID",
        session_id: "Session ID",
        workload_id: "Workload ID",
        status: "Status",
        source_confidence: "Confidence",
        media_count: "Media count",
        uploaded_media_count: "Uploaded media",
        rating: "Rating",
        display_date: "Date",
      },
      empty:
        "No echoes found. Run the local Echoflicks importer to load completed generated videos.",
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        administrator: "Admin",
        disabled: "Disabled",
        blog_role: "Blog role",
      },
      blog_roles: {
        none: "None",
        editor: "Editor (drafts)",
        publisher: "Publisher (drafts and live)",
      },
      create: {
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Echoflicks CRM",
    },
    common: {
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    whatsapp: {
      action: "Send WhatsApp",
      aside_title: "WhatsApp",
      opt_in_label: "Marketing opt-in",
      opt_in: {
        approved: "Approved",
        denied: "Denied",
        unknown: "Unknown",
      },
      stopped: "Stopped",
      nav: "Broadcasts",
      block_reasons: {
        contact_not_found:
          "This contact is not available in the live WhatsApp dashboard.",
        freeform_window_expired:
          "The 24-hour WhatsApp service window is closed. Use an approved template.",
        local_whatsapp_function_not_configured:
          "WhatsApp sending is not configured for local Supabase mode.",
        missing_whatsapp_user_id:
          "This contact is not linked to a WhatsApp user.",
        no_recent_inbound_message:
          "Freeform messages require a recent inbound WhatsApp message.",
        opted_out: "This contact opted out of WhatsApp messages.",
        unknown:
          "This contact cannot receive a freeform WhatsApp message right now.",
      },
      description:
        "Compose and send an outbound WhatsApp message to this contact.",
      error: "WhatsApp message failed",
      freeform_available: "Freeform available",
      freeform_mode: "Freeform",
      marketing_opted_out_hint:
        "Opted out of marketing: broadcasts and templates stay off, but freeform replies are allowed while the 24-hour window is open.",
      loading: "Checking WhatsApp",
      no_messages: "No outbound WhatsApp messages yet",
      placeholder: "Write a WhatsApp reply...",
      recent_messages: "Recent outbound messages",
      requires_template_error:
        "Freeform WhatsApp messages require an active 24-hour service window.",
      send: "Send",
      sending: "Sending...",
      sent: "WhatsApp message accepted",
      template: "Template",
      template_mode: "Template",
      template_required: "Template required",
      title: "Send WhatsApp message",
      timeline_empty: "No WhatsApp conversation messages yet",
      timeline_error: "Conversation history failed to load",
      timeline_loading: "Loading conversation...",
      timeline_title: "WhatsApp conversation",
      open_in_inbox: "Open in Felix Inbox",
      window_expires: "Freeform window expires %{time}",
      inbox: {
        nav: "Inbox",
        title: "Inbox",
        description:
          "Customers whose last WhatsApp message Felix could not handle. Claim a conversation, reply from the chat, and it resolves itself.",
        tabs: {
          needs_reply: "Needs reply",
          claimed: "Claimed",
          resolved: "Resolved",
        },
        empty: {
          needs_reply: "Nobody is waiting for a reply right now.",
          claimed: "No claimed conversations.",
          resolved: "Nothing resolved yet.",
        },
        loading: "Loading inbox...",
        error: "Could not load the inbox",
        load_more: "Load more",
        showing: "Showing %{count} of %{total}",
        oldest_waiting: "oldest waiting %{time}",
        columns: {
          contact: "Contact",
          reason: "Reason",
          waiting: "Waiting",
          window: "Window",
          owner: "Owner",
          actions: "Actions",
        },
        messages_count: "%{smart_count} message |||| %{smart_count} messages",
        claimed_by: "Claimed by %{name}",
        resolved_by: "Resolved by %{name}",
        unassigned: "Unassigned",
        window_open: "Freeform %{time} left",
        window_closed: "Template needed",
        window_unknown: "No inbound yet",
        priority: {
          high: "High priority",
          normal: "Normal priority",
          low: "Low priority",
        },
        reason_unknown: "Needs a human",
        actions: {
          claim: "Claim",
          resolve: "Resolve",
          reopen: "Reopen",
          open_chat: "Open chat",
          open_echo: "Open Echo",
          claim_done: "Conversation claimed",
          resolve_done: "Conversation resolved",
          reopen_done: "Conversation reopened",
          claim_hint:
            "Pauses Felix for this contact on WhatsApp. Felix answers again when you release or resolve, or when the claim lapses after a stretch with no reply from the team.",
          release: "Release",
          release_hint:
            "Hand this contact back to Felix and back to the queue.",
          release_done: "Released. Felix answers this contact again.",
          release_confirm:
            "Release %{name}'s claim? Felix will answer this contact again.",
        },
        web_stall: {
          felix: "🌐 Web Echo · Felix interview stalled",
          render: "🌐 Web Echo · render stalled",
          unknown: "🌐 Web Echo stalled",
        },
        banner: {
          needs_reply: "Felix needs a hand with this conversation",
          claimed: "Claimed by %{name}",
          waiting: "waiting %{time}",
          messages:
            "%{smart_count} unanswered message |||| %{smart_count} unanswered messages",
        },
        composer: {
          placeholder:
            "Reply on WhatsApp (Enter to send, Shift+Enter for a new line)",
          send: "Send",
          send_template: "Send template",
          keep_open: "Keep open",
          keep_open_hint:
            "Sending normally resolves the inbox conversation. Tick to keep it open.",
          sender: "Sender",
          checking: "Checking the WhatsApp window...",
          blocked: "Freeform replies are blocked",
          no_sender: "No verified WhatsApp sender is available.",
        },
        load_older: "Load older messages",
        loading_older: "Loading...",
        capability: {
          unavailable: "Customer inbox is unavailable",
          disabled:
            "The connected dashboard API does not advertise the customer inbox.",
        },
        filter: {
          category: "Inbox",
          needs_reply: "Needs reply",
        },
      },
      capabilities: {
        analytics_disabled:
          "The connected dashboard API does not advertise WhatsApp broadcast analytics support.",
        analytics_unavailable: "Broadcast analytics is unavailable",
        broadcasts_disabled:
          "The connected dashboard API does not advertise WhatsApp broadcast support.",
        broadcasts_unavailable: "Broadcasts are unavailable",
        media_disabled:
          "Template media upload is not enabled in this environment.",
        library_disabled:
          "The dashboard API has not been linked to AWS End User Messaging Social for Meta's template library.",
        library_unavailable: "Template library is unavailable",
        sync_disabled:
          "The dashboard API is reachable, but WABA template catalog sync is not configured.",
        sync_unavailable: "Meta sync is unavailable",
        templates_disabled:
          "The connected dashboard API does not advertise WhatsApp template support.",
        templates_unavailable: "Templates are unavailable",
        worker_disabled:
          "The broadcast worker is not enabled. Only inline or manually resumed sends may run.",
        worker_unavailable: "Broadcast worker is unavailable",
      },
      buttons: {
        use_suggested: "Suggested labels",
        preset_create: "Felix starts a new Echo",
        preset_create_command:
          "Felix starts a new Echo (the slash is optional)",
        preset_stop: "Felix opts this contact out of promotions",
        intent_create: "Felix will start a new Echo when this is tapped.",
        intent_stop: "Felix will opt the contact out of promotions.",
        intent_text_only:
          "Felix usually understands this, but not on every delivery path. Pick a suggested label to be certain.",
        intent_callback_only:
          "Felix often will NOT understand this — taps normally arrive as plain text, which this wording does not match. Pick a suggested label.",
        intent_unrecognized:
          'Felix will not recognise this label. Tapping it lands the contact on the "didn\'t quite catch that" reply. Pick a suggested label, or keep it as a URL button.',
      },
      templates: {
        actions: "Actions",
        appeal: "Appeal note",
        appeal_placeholder:
          "What changed, and why should this template be approved?",
        appeal_saved: "Appeal note saved",
        appeal_title: "Template rejection",
        body: "Body",
        category: "Category",
        empty: "No WhatsApp templates yet",
        footer: "Footer",
        header: "Header",
        header_example: "Header example",
        header_text: "Header text",
        language: "Language",
        library: "Template library",
        library_empty: "No library templates found",
        library_imported: "Template imported from the library",
        name: "Name",
        my_templates: "My templates",
        new: "New template",
        policy_note:
          "Approved templates can be used outside the 24-hour service window. Rejected, pending, paused, and disabled templates are blocked before send.",
        policy_title: "Template approval gates",
        quality: "Quality",
        body_example: "Example for {{%{placeholder}}}",
        add_contact_number: "Add contact number",
        add_learn_more: "Add learn more link",
        add_security: "Add security recommendation",
        add_tracking: "Add tracking link",
        button_inputs: "Button inputs",
        button_no_inputs: "No inputs are needed for this button.",
        button_phone: "Phone number",
        button_quick_reply: "Quick reply",
        button_text: "Button text",
        button_type: "Type",
        button_url: "Button URL",
        button_url_cta: "Website",
        code_expiration: "Code expiration minutes",
        duplicate_name: "Template name already exists",
        duplicate_name_help:
          "Choose another name. WhatsApp template names are unique per language in the WABA.",
        import: "Import",
        import_history: "Import history",
        import_history_empty: "No template imports yet",
        import_synced: "Import status synced",
        imported_from: "Imported from %{name}",
        imported_from_label: "Imported from",
        import_title: "Import library template",
        operator: "Operator",
        operator_missing: "Operator identity missing",
        otp_type: "OTP type",
        preview: "Preview",
        preview_empty_body: "Template body preview",
        sample_media: "Sample media",
        sample_media_help:
          "Upload the image, document, or video sample Meta will review with this template.",
        sample_media_limits:
          "Images: JPEG/PNG up to 5 MB. Videos: MP4/3GP up to 16 MB. GIFs should be uploaded on VIDEO templates and converted to MP4 by the backend when enabled.",
        sample_media_ready:
          "Sample media is uploaded and ready for template submission.",
        sample_media_video_help:
          "Upload an MP4/3GP video sample. GIF uploads are accepted only when backend conversion to MP4 is enabled.",
        save_appeal: "Save note",
        save_draft: "Save draft",
        saved: "Template saved",
        search: "Search",
        search_placeholder: "Receipt, delivery, code...",
        sender: "Sender",
        status: "Status",
        submit: "Submit for approval",
        submitted: "Template submitted",
        summary: "%{approved} approved of %{total} templates",
        sync: "Sync",
        sync_all: "Sync from Meta",
        sync_all_done: "Templates synced from Meta",
        sync_status: "Sync status",
        synced: "Template synced",
        add_quick_reply: "Add reply",
        add_url_button: "Add URL",
        no_template_buttons: "No buttons added.",
        remove_button: "Remove button",
        template_buttons: "Buttons",
        template_buttons_help:
          "Use quick replies for Create my movie and Stop promotions; add one static HTTPS URL when needed.",
        button_slash_help:
          'A quick reply sends its own label back to Felix, so the label is the command. The leading slash is optional — Felix reads "/create" and "Create" the same way; what matters is that the wording is one he knows.',
        title: "WhatsApp templates",
        topic: "Topic",
        unpause: "Unpause",
        unpaused: "Template unpaused",
        updated: "Updated",
        usecase: "Use case",
        zero_tap_terms: "Zero-tap terms accepted",
      },
      broadcasts: {
        actions: "Actions",
        add_pasted_ids: "Add IDs",
        advanced_contact_ids: "Paste contact IDs",
        all_matching_selected:
          "%{smart_count} matching contact selected |||| %{smart_count} matching contacts selected",
        all_matching_selected_more: "%{count}+ matching contacts selected",
        clear_selection: "Clear",
        contact: "Contact",
        contact_ids: "Contact IDs",
        created: "Created",
        created_success: "Broadcast created",
        edit: "Edit broadcast",
        edit_action: "Edit",
        edited: "Edited %{date}",
        edit_blocked_hint:
          "Only a scheduled broadcast that has not started sending can be edited.",
        empty: "No WhatsApp broadcasts yet",
        error: "Error",
        name: "Name",
        name_placeholder: "May promo, renewal reminder...",
        live_preview: "How it will look",
        live_preview_empty: "Pick a template to see the message.",
        live_preview_missing: "Not filled in: %{placeholders}",
        message_preview: "Message preview",
        header_media: "Header image",
        header_media_use_template: "Use template image",
        header_media_upload_different: "Upload a different image",
        header_media_from_template:
          "Using the template's image. People will receive this.",
        header_media_template_unsendable:
          "This template was imported without a stored image. Upload one to use it in a broadcast.",
        header_media_dropzone: "Drag an image here, or click to choose",
        header_media_dropzone_hint: "%{noun} · up to %{limit}",
        header_media_uploading: "Uploading…",
        header_media_format_mismatch:
          "That file type isn't allowed for this template.",
        header_media_too_large: "That file is too large (max %{limit}).",
        eligibility_unknown: "Unknown",
        explicit_selected:
          "%{smart_count} contact selected |||| %{smart_count} contacts selected",
        hidden_selected:
          "%{smart_count} selected outside this page |||| %{smart_count} selected outside this page",
        missing_whatsapp_id: "No WhatsApp",
        more_previews: "+%{count} more",
        matching_contacts:
          "%{smart_count} contact matches filters |||| %{smart_count} contacts match filters",
        matching_contacts_excluded:
          "%{smart_count} matching contact excluded |||| %{smart_count} matching contacts excluded",
        matching_contacts_more: "%{count}+ contacts match filters",
        new: "New broadcast",
        next_page: "Next page",
        no_contacts: "No contacts found",
        opted_out: "Opted out",
        page_count: "Page %{page}",
        paste_contact_ids: "contact_123, contact_456",
        previous_page: "Previous page",
        preview: "Preview",
        progress: "Progress",
        recipient_search: "Find recipients",
        recipient_search_placeholder: "Search contacts",
        recipients: "Recipients",
        compliance_attestation:
          "I confirm these recipients have opted in and this broadcast follows WhatsApp Business template policy.",
        include_not_opted_in_label: "Include contacts without recorded opt-in",
        include_not_opted_in_hint:
          "Also sends to contacts whose opt-in is unknown. Opted-out contacts are always excluded.",
        included_without_opt_in: "%{count} without recorded opt-in",
        insert_variable: "Variable",
        missing_variable_hint:
          "%{count} recipients skipped: a personalization variable has no value for them and no fallback text. Add a fallback after the | in the token to include them.",
        variables: {
          portal_url: "Tracked portal link",
          rated_echo_title: "Rated Echo title",
          latest_echo_title: "Latest Echo title",
          first_name: "First name",
          last_rating: "Latest star rating",
        },
        send_blocked_not_opted_in_hint:
          '%{count} recipients have no recorded opt-in and are being skipped. Tick "Include contacts without recorded opt-in" above to send to them (opted-out contacts are still excluded).',
        schedule: "Schedule broadcast",
        scheduled_for: "Scheduled for",
        scheduled_for_short: "Scheduled %{date}",
        selected_contacts:
          "%{smart_count} selected contact |||| %{smart_count} selected contacts",
        select_all_matching: "Select all matching",
        select_page: "Select page",
        send_later: "Send later",
        send_mode: "Send mode",
        send_now: "Send now",
        send: "Send broadcast",
        status: "Status",
        save_changes: "Save changes",
        summary: "%{total} broadcasts",
        template: "Template",
        title: "WhatsApp broadcasts",
        updated: "Updated",
        updated_success: "Broadcast updated",
        whatsapp_ready: "Ready",
        cohort: {
          title: "Audience cohorts",
          echo_activity: "Echo activity",
          lifecycle: "Lifecycle stage",
          uses: "Uses",
          videos: "Completed echoes",
          satisfaction: "Average stars",
          geography: "Geography",
          recency: "Recency",
          reachability: "Reachability",
          acquisition: "Acquisition source",
          acquisition_website: "🌐 Website",
          acquisition_ctwa: "💬 Meta → WhatsApp",
          acquisition_organic: "🌱 Organic",
          acquisition_snap: "📸 Snap (Instax booth)",
          acquisition_link: "🔗 Tracking link",
          acquisition_launchpad: "🚀 Launchpad",
          acquisition_my_web: "💻 My Echoflicks web",
          language: "Language",
          language_any: "Language: %{language}",
          include: "Include",
          exclude: "Exclude",
          explicit_geo_disabled: "Individual contacts selected",
          broadcast_to_segment: "Broadcast to this segment",
          selected_segment: "Cohort segment",
          continent_AF: "Africa",
          continent_AS: "Asia",
          continent_EU: "Europe",
          continent_NA: "North America",
          continent_OC: "Oceania",
          continent_SA: "South America",
          continent_UNKNOWN: "Unknown",
          geo_continents_any: "Continents: %{continents}",
          geo_continents_none: "Exclude: %{continents}",
          geo_countries_any: "Countries: %{countries}",
          geo_countries_none: "Exclude countries: %{countries}",
          geo_overlap:
            "A continent cannot be both included and excluded in the same broadcast.",
          lifecycle_prospect: "Prospect",
          lifecycle_abandoned_photos: "Abandoned at photos",
          lifecycle_abandoned_story: "Abandoned at story",
          lifecycle_abandoned_director: "Abandoned at director",
          lifecycle_generating: "Generating",
          lifecycle_failed: "Failed",
          lifecycle_delivered_once: "Delivered once",
          lifecycle_repeat: "Repeat creator",
          echo_today: "Echo today",
          echo_this_week: "Echo this week",
          echo_before_this_week: "No Echo this week",
          echo_before_this_month: "No Echo this month",
          echo_before_last_month: "Dormant since last month",
          uses_0: "No uses",
          uses_1: "1 use",
          uses_2to4: "2-4 uses",
          uses_5plus: "5+ uses",
          videos_0: "No videos",
          videos_1: "1 video",
          videos_2plus: "2+ videos",
          average_rating_champion: "Champions (4.5+)",
          average_rating_happy: "Happy (3.5-4.49)",
          average_rating_mixed: "Mixed (2.5-3.49)",
          average_rating_unhappy: "Unhappy (<2.5)",
          average_rating_none: "No rating",
          rating_promoter: "Promoters (4-5)",
          rating_passive: "Passive (3)",
          rating_detractor: "Detractors (1-2)",
          rating: "Latest rating",
          rating_stars: "Rated %{stars} ★",
          rating_unrated: "Unrated",
          explicit_rating_disabled: "Individual contacts selected",
          active_within_days: "Active within %{days}d",
          dormant_beyond_days: "Dormant beyond %{days}d",
          window_open: "Open 24h window",
          window_closed: "Window closed (template)",
          reachable: "Reachable now",
          reachable_only: "Reachable only",
          messaging_window: "Messaging window",
          messaging_window_any: "Any window",
          messaging_window_open: "Free-form open",
          messaging_window_closed: "Template required",
          refine: "Refine reachability",
          opted_in: "Opted in",
          summary: "Cohort: %{summary}",
          eligible_of_total: "%{eligible} eligible of %{total}",
          scanned: "%{count} scanned",
          pages: "%{count} pages",
          incomplete: "Incomplete scan",
          computed_at:
            "Computed at %{time}; window and recency reflect that moment.",
          skip_reason_missing_whatsapp_user_id: "No WhatsApp identity",
          skip_reason_opted_out: "Opted out",
          skip_reason_duplicate_whatsapp_user_id: "Duplicate WhatsApp contact",
          detractor_marketing_warning:
            "Some recipients are detractors. Prefer a UTILITY service-recovery template over MARKETING.",
        },
      },
      analytics: {
        title: "Broadcast analytics",
        not_enabled:
          "Broadcast analytics is not enabled for this environment yet.",
        view: "View analytics",
        read_help: "Read is a WhatsApp read receipt, not a guaranteed open.",
        inferred_help: "Inferred after the configured window.",
        cost_title: "Cost",
        total_spend: "Total spend",
        cost_per_delivered: "Cost per delivered",
        cost_per_reply: "Cost per reply",
        billable_messages: "Billable messages",
        cost_unavailable: "Cost data unavailable",
        clicks_title: "Template clicks",
        clicked_url_button: "URL button clicks",
        clicked_quick_reply: "Quick reply clicks",
        template_analytics_unavailable:
          "Template click analytics is unavailable.",
        reply: "Reply",
        open_conversation: "Open conversation",
        pricing_category: "Pricing category",
        unavailable: "Unavailable",
      },
    },
    changelog: {
      title: "Changelog",
    },
    lab_results: {
      nav: "Lab results",
      title: "Lab results",
      subtitle:
        "Side-by-side review of lab experiments: same inputs, different treatments, full resolution.",
      empty: "No experiment results published yet.",
      load_error: "Could not load experiment results",
      not_found: "This experiment does not exist (or was unpublished).",
      back: "All lab results",
      photos: "%{smart_count} photo |||| %{smart_count} photos",
      arms: "%{smart_count} arm |||| %{smart_count} arms",
      legend: "What you are looking at",
      pick_photo: "Pick a photo (← → keys also work)",
      view_compare: "Side by side",
      view_wipe: "Wipe",
      view_grid: "Grid",
      open_full: "Open at full resolution",
      metrics: "Metrics",
      arm: "Arm",
      wipe_left: "Left",
      wipe_right: "Right",
      wipe_slider: "Wipe position",
      wipe_help:
        "Drag the slider or drag across the image to reveal the right-hand arm.",
      zoom_100: "View at 100 %",
      zoom_fit: "Fit to screen",
      lightbox_help: "← → arms · ↑ ↓ photos · Z zoom · Esc close",
      videos: "%{smart_count} film |||| %{smart_count} films",
      pick_video: "Pick a film (← → keys also work)",
      play_both: "Play both",
      pause_both: "Pause both",
      restart: "Back to the start",
      seek: "Position in both films",
      listen: "Listen",
      listening: "Listening",
      sync_help:
        "Both films play in lockstep and only one is audible: switch the sound with the Listen buttons or the 1 / 2 keys to compare soundtracks at the same frame. Space plays and pauses.",
      gallery_help:
        "Everything is on this page. Press play on any clip; starting one pauses the others.",
      playground: {
        tab: "Playground",
        title: "Generate with this recipe",
        subtitle:
          "Render a photo with this entry's LoRA and prompts on our own GPUs. Move the strength to see what more or less does.",
        status_unknown: "Checking the GPU…",
        status_ready: "GPU ready · %{gpu}",
        status_rendering: "GPU rendering a playground image · %{gpu}",
        status_production: "GPU busy with a production render · %{gpu}",
        status_offline: "GPU offline: generations wait until a tower is back",
        status_error: "GPU status unavailable",
        input: "Photo",
        input_photo_hint:
          "Pick another photo in the strip above, or upload your own.",
        input_upload_hint: "Your upload. Switch back to use the entry's photo.",
        upload: "Upload",
        use_entry_photo: "Use the entry's photo",
        upload_failed: "Upload failed",
        lora: "LoRA",
        prompt: "Prompt",
        custom: "Custom",
        custom_hint:
          "{trigger} and {gear} are replaced with the LoRA's trigger words. <image1> is your photo.",
        strength: "Strength",
        strength_less: "%{value} · subtler, sharper",
        strength_more: "%{value} · stronger look, softer",
        no_lora_hint:
          "No LoRA: the photo is re-rendered with the prompt only, strength has no effect.",
        seed: "Seed",
        seed_published: "Same as published",
        seed_published_missing: "Only for the entry's own photos",
        seed_random: "Random",
        seed_fixed: "Fixed",
        seed_hint:
          "Same photo + same seed + same settings = the same image. Change only the strength to compare fairly.",
        generate: "Generate",
        sweep: "Strength sweep (%{values})",
        production_first:
          "Runs on our GPU towers. Production renders always go first, so a generation can wait a few minutes when Echoes are rendering.",
        generate_failed: "Could not start the generation",
        empty:
          "Your generations appear here. Pick a photo, set the strength and press Generate.",
        state_queued: "Queued",
        state_waiting_gpu: "Waiting for the GPU",
        state_waiting_production: "Waiting for a production render to finish",
        state_running: "Rendering",
        state_done: "Done",
        state_failed: "Failed",
        state_cancelled: "Cancelled",
        state_stalled: "The GPU worker stopped responding",
        elapsed: "%{seconds} s",
        cancel: "Cancel",
        no_lora: "No LoRA",
        strength_value: "Strength %{value}",
        seed_value: "seed %{seed}",
        timing: "%{render} s render · %{wait} s waiting for the GPU",
        before: "Before",
        after: "After",
        wipe: "Before/after position",
        open_full: "Open full size",
        history: "Generations for this entry",
        history_error: "Could not load generations",
        history_empty: "Nothing generated yet.",
      },
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Echoflicks CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    header: {
      import_data: "Import data",
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import Data",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
      home: "Home",
      more: "More",
      chat: "Chat",
      more_description: "Every other workspace, grouped by team.",
    },
    profile: {
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Echoflicks CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
